import React from "react"
import PropTypes from "prop-types"

import { DarkPurple } from "design-constants"

import { parseHtmlToReact } from "imports/desktopHelperFunctions"
import { SegueLink } from "app/static/frontend/middleware/segueMiddleware"

import * as S from "app/static/frontend/profiles-new/components/ContactCard/style.js"

import { ContactCard as DSContactCard } from "quorumdesign"

import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import { SupporterContactCardData } from "@/components/ProfileSupporter/SupporterContactCardData"

const ContactCard = ({ data }) => {
    const contactInfoObj = data && data.length && data[0]
    const isContactDataType = contactInfoObj && contactInfoObj.isContactDataType

    return (
        contactInfoObj && (
            <S.ContactCardContainer>
                <DSContactCard
                    circleColor={contactInfoObj.circleColor}
                    circleFontColor={DarkPurple}
                    circleIcon={contactInfoObj.icon}
                    circleIconFamily={contactInfoObj.iconFamily}
                    circleImgUrl={contactInfoObj.imageUrl}
                    detailItems={contactInfoObj.detailItems}
                    infoItems={
                        contactInfoObj.infoItems &&
                        contactInfoObj.infoItems
                            .map((item) => {
                                if (!item) {
                                    return null
                                }

                                if (item.subItems) {
                                    return {
                                        ...item,
                                        text: item.subItems.map((subItem, index) => (
                                            <React.Fragment>
                                                <SegueLink to={subItem.href}>{subItem.text}</SegueLink>
                                                {index < item.subItems.length - 1 && ", "}
                                            </React.Fragment>
                                        )),
                                    }
                                } else if (item.href) {
                                    return {
                                        ...item,
                                        text: <SegueLink to={item.href}>{item.text}</SegueLink>,
                                    }
                                } else {
                                    return {
                                        ...item,
                                        text: item.isHtml ? parseHtmlToReact(item.text) : item.text,
                                    }
                                }
                            })
                            .filter((item) => item)
                    }
                    isV2Image={isFeatureEnabled("ff_new_profile_picture") && contactInfoObj.isV2Image}
                    name={contactInfoObj.name}
                    subtitle={contactInfoObj.subtitle}
                    contactDataTabs={
                        isContactDataType &&
                        isFeatureEnabled("ff_ngg_pac_supporter_synced_contacts") && (
                            <SupporterContactCardData data={contactInfoObj} />
                        )
                    }
                />
            </S.ContactCardContainer>
        )
    )
}

ContactCard.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            circleColor: PropTypes.string,
            icon: PropTypes.string,
            imageUrl: PropTypes.string,
            // items to display on the right side of the card
            detailItems: PropTypes.shape({
                // name of the detail field
                label: PropTypes.string,
                // text for the detail field
                text: PropTypes.string,
            }),
            // items to display under the name, right of the circle
            infoItems: PropTypes.arrayOf(
                PropTypes.shape({
                    // quorum location to link this item's text to
                    href: PropTypes.string,
                    // if the text for the info item is html
                    isHtml: PropTypes.bool,
                    // name of the info field
                    label: PropTypes.string,
                    // text for the info field
                    text: PropTypes.string,
                    // style of the text for this info field
                    textType: PropTypes.oneOf(["primary", "secondary"]),
                }),
            ),
            isV2Image: PropTypes.bool,
            name: PropTypes.string,
            subtitle: PropTypes.string,
        }),
    ),
}

export default ContactCard
